import { ComponentProps } from 'react'
import { webchatClasses } from '../../styles/classes'

import { X } from 'lucide-react'
import { Avatar } from '../Avatar'

type MessagePreviewProps = ComponentProps<'div'> & {
  avatarUrl?: string
  botName?: string
  description?: string
  onClose?: () => void
}

export const MessagePreview = ({
  ref,
  children,
  onClick,
  avatarUrl,
  botName,
  description,
  onClose,
  ...props
}: MessagePreviewProps) => {
  const { messagePreview } = webchatClasses
  const { container, closeButton, message: messageClass, avatar, description: descriptionClass } = messagePreview ?? {}

  return (
    <div {...props} {...container} ref={ref} onClick={onClick}>
      <Avatar src={avatarUrl} {...avatar}>
        {botName || 'Bot'}
      </Avatar>
      <p {...messageClass}>{children}</p>
      <p {...descriptionClass}>{description}</p>
      <X
        {...closeButton}
        onClick={(e) => {
          e.stopPropagation()
          onClose?.()
        }}
      />
    </div>
  )
}

MessagePreview.displayName = 'MessagePreview'
